import cx from 'classnames';

export default function Badge({ className = '', children }) {
  return (
    <div
      className={cx(
        className,
        'tw-inline-flex tw-text-bold tw-rounded tw-uppercase tw-leading-tight',
      )}
      style={{ padding: '0.25em' }}>
      {children}
    </div>
  );
}
